import { render } from "./LecturesWrapper.vue?vue&type=template&id=34c414b3"
import script from "./LecturesWrapper.vue?vue&type=script&lang=js"
export * from "./LecturesWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__